module.exports = __webpack_public_path__ + "1388239cb86df7506d58b5c71cffc873.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/envelope.png
// module id = 1039
// module chunks = 0